import Repository from '../Repository';

const url = '/subscription';

export default {
    createSetupIntent() {
        return Repository.get(`${url}/setup-intent`,{localLoading: true});
    },
    addPaymentMethod(pmId) {
        return Repository.post(`${url}/add-payment-method`, {pm_identifier: pmId}, {localLoading: true})
    },
    getStatus() {
        return Repository.get(`${url}/status`, {localLoading: true});
    },
    subscribe(pmId) {
        return Repository.post(`${url}/subscribe`, {pm_id: pmId}, {localLoading: true})
    },

    cancelSubscription() {
        return Repository.post(`${url}/cancel-subscription`, null,{localLoading: true})
    },

    resumeSubscription() {
        return Repository.post(`${url}/resume-subscription`, null, {localLoading: true})
    },

    getInvoices() {
        return Repository.get(`${url}/invoices`, {localLoading: true});
    },

    downloadInvoice(id) {
        return Repository.get(`${url}/invoice/${id}/download`, {localLoading: true});
    }
}
